import { put } from 'redux-saga/effects';
import { adminSetPoliciesAction } from 'pages/administration.page/actions';
import { updatePoliciesApi } from 'common/api/website';
import { toast } from 'react-toastify';
import { tokenizePolicies } from 'pages/administration.page/utils';
import i18next from 'i18next';

/**
 * @param {{websiteId: number, policies: policyModelRaw[]}} payload
 * @return {IterableIterator<*>}
 */
export function* updatePoliciesEffect({ payload }) {
  try {
    const policies = yield updatePoliciesApi(payload.websiteId, payload.policies);
    yield toast.success(i18next.t('policies_has_been_saved'));
    yield put(adminSetPoliciesAction(tokenizePolicies(policies)));
  } catch (error) {}
}
